import { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { fetchOdczytyWm } from "../../../Redux/Actions";
import { Tooltip } from "@mui/material";
import { handleFocus, handleBlur } from "../../../functions/utilities";

const WodaOdczytyRazemDodajOkres = props => {


    const { wybranaWspolnota, setShowDodajOkres, setOpenDialog, setMessage, handlePokazOkresy } = props;

    const dispatch = useDispatch();

    const [stany, setStany] = useState({
        pd: "",
        wzp: 0,
        wcp: 0,
        kd: "",
        wzk: 0,
        wck: 0,
        mz: 0,
        ep: 0,
        kpw: 0,
        m3: 0,
        opubl: 0,
        msc: ""
    });

    const { pd, wzp, wcp, kd, wzk, wck, mz, ep, kpw, m3, opubl, msc } = stany;

    const handleP = e => setStany( prevState => ({...prevState, pd: e.target.value}) );
    const handleK = e => setStany( prevState => ({...prevState, kd: e.target.value}) );
    const handleWzp = e => setStany( prevState => ({...prevState, wzp: e.target.value}) );
    const handleWzk = e => setStany( prevState => ({...prevState, wzk: e.target.value}) );
    const handleWcp = e => setStany( prevState => ({...prevState, wcp: e.target.value}) );
    const handleWck = e => setStany( prevState => ({...prevState, wck: e.target.value}) );

    const handleMz = e => setStany( prevState => ({...prevState, mz: e.target.value}) );
    const handleEp = e => setStany( prevState => ({...prevState, ep: e.target.value}) );
    const handleM3 = e => setStany( prevState => ({...prevState, m3: e.target.value}) );

    const handleOpubl = e => setStany( prevState => ({...prevState, opubl: e.target.value}));
    const handleMsc = e => setStany( prevState => ({...prevState, msc: e.target.value}))

    const handleAnuluj = () => {
        setStany({
            pd: "",
            wzp: 0,
            wcp: 0,
            kd: "",
            wzk: 0,
            wck: 0,
            mz: 0,
            ep: 0,
            kpw: 0,
            m3: 0,
            opubl: 0,
            msc: ""
        });
        setShowDodajOkres(false);   
    }

    const handleZapisz = async () => {
        
        if (pd == '' ) {
            setMessage('Podaj datę początku okresu.');
            setOpenDialog(true);
        } else if (opubl == 1 && (msc == '' || msc == null)) {
            setMessage('Podaj miesiąc, w którym rozliczenie będzie widoczne.');
            setOpenDialog(true);
        } else {
            try {
                axios.post("/api/odczyty-wm/dodaj", { 
                    id_wspolnoty: wybranaWspolnota?.id,
                    okres_poczatek: pd == '' ? null : pd,
                    okres_koniec: kd == '' ? null : kd,
                    ciepla_stan_poczatek: wcp,
                    ciepla_stan_koniec: wck,
                    zimna_stan_poczatek: wzp,
                    zimna_stan_koniec: wzk,
                    moc_zamowiona: mz,
                    energia_pobrana: ep,
                    metr_3_zimnej: m3,
                    opublikowany: opubl,
                    miesiac: msc == "" ? null : msc
                }).then(response => {
                    dispatch(fetchOdczytyWm(wybranaWspolnota?.id)); 
                    handleAnuluj();
                    handlePokazOkresy();
                })
            } catch (error) {
                console.error('Błąd podczas dodawania danych:', error);
            }
        }
    }

    useEffect( () => setStany( prevState => ({...prevState, kpw: parseFloat(mz) + parseFloat(ep)}) ), [mz, ep]);

    return (
        <div className="ramka woda-nowy-okres">
            <p>Dodaj okres rozliczeniowy</p>
            <div className="form">
                <div className="row">
                    <div>
                        <label htmlFor="p">
                            Początek:
                        </label>
                        <input 
                            type="date"    
                            id="p"
                            value={stany.pd}
                            onChange={handleP}
                        />
                    </div>
                    <div>
                        <label htmlFor="wzp">
                            Stan w. zimnej:
                        </label>
                        <input 
                            type="number" 
                            id="wzp" 
                            value={stany.wzp}
                            onChange={handleWzp}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <label htmlFor="k">
                            Koniec:
                        </label>
                        <input 
                            type="date"    
                            id="k"
                            value={kd}
                            onChange={handleK}
                        />
                    </div>
                    <div>
                        <label htmlFor="wzk">
                            Stan w. zimnej:
                        </label>
                        <input 
                            type="number" 
                            id="wzk" 
                            value={wzk}
                            onChange={handleWzk}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <label htmlFor="kpw">
                            Koszt podgrzania wody (wg faktur PEC):  
                        </label>
                        <input 
                            type="number" 
                            id="kpw" 
                            value={kpw}
                            disabled
                        />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <label htmlFor="mz">
                            Moc zamówiona
                        </label>
                        <input 
                            type="number" 
                            id="mz" 
                            value={mz}
                            onChange={handleMz}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                    <div>
                        <label htmlFor="ep">
                            Energia pobrana
                        </label>
                        <input 
                            type="number" 
                            id="ep" 
                            value={ep}
                            onChange={handleEp}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <label htmlFor="m3">
                            Kosz 1m³ zimnej wody (wg PWiK):
                        </label>
                        <input 
                            type="number" 
                            id="m3" 
                            value={m3}
                            onChange={handleM3}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="opub">
                        <label htmlFor="opubl">
                            <b>Czy opublikowany:</b>
                        </label>
                        <select 
                            id="opubl"
                            value={opubl}
                            onChange={handleOpubl}
                        >
                            <option value={1}>
                                Tak
                            </option>
                            <option value={0}>
                                Nie
                            </option>
                        </select>
                        <Tooltip
                            title="Ważny jest miesiąc i rok, dzień obojętnie który."
                            placement='top'
                        >
                            <input 
                                type="date"    
                                id="msc"
                                value={stany.msc}
                                onChange={handleMsc}
                            />
                        </Tooltip>
                    </div>
                </div>
            </div>

            <div className="buttons">
                <button onClick={handleZapisz}>
                    Zapisz
                </button>
                <button onClick={handleAnuluj}>
                    Anuluj
                </button>
            </div>
        </div>
    )
}

export default WodaOdczytyRazemDodajOkres;